/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Chip,
  IconButton,
  Link as LinkMui,
  Menu,
  MenuItem,
  Pagination,
  Stack,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { get, isEmpty, map, toString, find } from "lodash";
import { Link } from "react-router-dom";
import { Alert, Notification, Question } from '../../../components/form';
import Table from "../../../components/form/TableFilter";

import Layout from "../../../components/layout/Layout";
import { PageSize, countPage } from "../../../config/const";
import Toolbar from "./Toolbar";

import { getProvidersRoute } from "../../../store/transactions/thunk/providersRoutes/getAll";
import { getInvoiceProvider } from "../../../store/transactions/thunk/invoiceProvider/getAll";
import { deleteInvoiceProvider } from "../../../store/transactions/thunk/invoiceProvider/delete";

const InvoicesProvider = () => {
  const [__] = useTranslation("invoiceProvider");
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
  const [openQuestion, setOpenQuestion] = useState(false);

  const invoice = useSelector(state => state.transactions.invoiceProvider);
  const put = useSelector(state => state.transactions.invoiceProvider.put);
  const delet = useSelector(state => state.transactions.invoiceProvider.delete);

  const invoiceStatus = __(`invoiceStatus`, { returnObjects: true });

  const getData = ({page, filters = filter}) => {
    dispatch(getInvoiceProvider({page, ...filters, Export: false }))
  }

  const getDataProviders = () => {
      dispatch(getProvidersRoute({ Export: true }));
    }

  const reload = () => getData({ page: 1})

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1 });
    getDataProviders();
  }, []);

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    getData({ page: 1, filters: updatedFilters });
  };

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  const onDelete = () => {
    dispatch(deleteInvoiceProvider(Number(selected)))
    setSelected({})
  }
  const handleDelete = (row) => () => {
    setAnchorEl(null)
    setOpenQuestion(true)
    setSelected(row)
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(put, "isSuccess", false)) { handleCloseMenu(); getData({ page: 1, filter }); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
  }, [put, delet])

  const headTable = [
    {
      key: "status",
      label: __(`table.cols.Status`),
      align: "center"
    },
    {
      key: "internalOdooOC",
      label: __(`table.cols.IdFacturaOc`),
      align: "center"
    },
    {
      key: "providersTrackingId",
      label: __(`table.cols.idInvoice`),
      align: "center"
    },
    {
      key: "creationDate",
      label: __(`table.cols.CreationDate`),
      align: "center"
    },
    {
      key: "providerName",
      label: __(`table.cols.ProviderName`),
      align: "left"
    },
    {
      key: "servicios",
      label: __(`table.cols.servicios`),
      align: "center"
    },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { width: 80, position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]

  const dataTable = map(get(invoice, "data.data", []), (row, i) => ({
    ...row,
    providersTrackingId: <LinkMui component={Link} to={toString(get(row, "providersTrackingId"))} >{get(row, "providersTrackingId")}</LinkMui>,
    creationDate: new Date(get(row, "creationDate")).toISOString().split('T')[0], // Formatear fecha sin hora
    status: <Chip label={get(find(invoiceStatus, ({ value }) => value === get(row, "statusId", 1)), "label")} sx={{ bgcolor: `${get(find(invoiceStatus, ({ value }) => value === get(row, "statusId", 1)), "color")}26`, color: get(find(invoiceStatus, ({ value }) => value === get(row, "statusId", 1)), "color") }} />,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(invoice, "isLoading", false)} />

      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        sizeFilters={125}
        loading={get(invoice, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(invoice, "data.totalRecord", 1))}
          page={get(invoice, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(invoice, "isLoading", false)}
        />
      </Stack>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        {Number(get(selected, "providersTrackingId")) > 0 && <Link to={toString(get(selected, "providersTrackingId"))}><MenuItem >{__(`table.menu.edit`)}</MenuItem></Link>}

        {get(selected, 'status') == 'OPEN' && <MenuItem onClick={handleDelete(get(selected, "providersTrackingId"))} >{__(`table.menu.delete`)}</MenuItem>}
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />

      <Question
        title={__("alert.deleteOrder.title")}
        detail={__("alert.deleteOrder.detail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </Layout>
  )
}

export default InvoicesProvider;


